import { SET_SOLANA_ADDRESS } from "./action";

export const initialState = { 
  publicKey : {},
  address : "",
  provider : "",
  wallet: {}
};

export default function solanaWalletReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SOLANA_ADDRESS:
      return { ...action.data };
    default:
      return state;
  }
}